module.exports = __webpack_public_path__ + "img/icon_white_temp.8254453c.png";